import { PAIR_FILTERS, type PairFilter } from './types'

/**
 * Что открыто на экране — в адресе (§7 клиента): фильтр списка `?f=` и страница `?p=`. Значения по умолчанию в адрес не
 * пишутся, поэтому «Все в списке», страница 1 — это чистый адрес источника.
 */
export const FILTER_PARAM = 'f'
export const PAGE_PARAM = 'p'

export function parseFilter(raw: string | null): PairFilter {
  return PAIR_FILTERS.find((filter) => filter === raw) ?? 'all'
}

export function parsePage(raw: string | null): number {
  const page = raw !== null && /^\d{1,6}$/.test(raw) ? Number(raw) : 1
  return page >= 1 ? page : 1
}

/** Адресные параметры с новым фильтром и страницей; чужие параметры (например, `?w=`) остаются как были. */
export function withView(current: URLSearchParams, filter: PairFilter, page: number): URLSearchParams {
  const next = new URLSearchParams(current)
  if (filter === 'all') next.delete(FILTER_PARAM)
  else next.set(FILTER_PARAM, filter)
  if (page <= 1) next.delete(PAGE_PARAM)
  else next.set(PAGE_PARAM, String(page))
  return next
}
